import { partnerServices } from "../../config/axios";
import MyVouchers from "../../views/Vouchers/MyVouchers/MyVouchers";
import {
  UNBLOCKCUSTOMEROPERATIONLIST_SUCCESS,
  UNBLOCKCUSTOMEROPERATIONLIST_FAILED,
  RESET_UNBLOCKCUSTOMEROPERATIONLIST,
  LOADING_UNBLOCKCUSTOMEROPERATIONLIST,
  NETWORK_ERROR_UNBLOCKCUSTOMEROPERATIONLIST,
} from "../types";

function resetUnBlockCustomerOperation() {
  return {
    type: RESET_UNBLOCKCUSTOMEROPERATIONLIST,
  };
}

const unBlockCustomerOperation = (data, authTokenIs) => async (dispatch) => {
  dispatch({
    type: LOADING_UNBLOCKCUSTOMEROPERATIONLIST,
  });

  await partnerServices
    .post("unBlockCustomerOperation", data, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.status) {
        case 400:
          dispatch(unBlockCustomerOperationDetailsFailed(res.data));
          break;
        case 200:
          dispatch(unBlockCustomerOperationDetailsSuccess(res.data));
          break;
        default:
          dispatch(unBlockCustomerOperationDetailsFailed());
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_UNBLOCKCUSTOMEROPERATIONLIST,
        payload: err,
      });
    });
};
function unBlockCustomerOperationDetailsFailed(data) {
  return {
    type: UNBLOCKCUSTOMEROPERATIONLIST_FAILED,
    payload: data,
  };
}
function unBlockCustomerOperationDetailsSuccess(data) {
  return {
    type: UNBLOCKCUSTOMEROPERATIONLIST_SUCCESS,
    payload: data,
  };
}

export { unBlockCustomerOperation, resetUnBlockCustomerOperation };
